import { z } from 'zod/v4';

export const GatewayHardwareMetricsSchema = z.object({
  cpu_memory: z.number(),
  cpu_utilization: z.number(),
  disk_used_pct: z.number(),
  gpu_memory: z.number(),
  gpu_utilization: z.number(),
});
